export default __webpack_public_path__ + "124191dc220c9a8d38cd19420daf645e.png";